import Vue from 'vue'
import _MIXPANEL_ from 'mixpanel-browser'
import store from '@/store/vuex'

const getBuildingId = () => {
  return store.getters.currentBuilding.objectId
}

/**
 * Version is for force cleaning local storage when data structure is changed
 */
const VERSION = 1

const MIXPANEL_STORAGE_KEY = process.env.MIXPANEL_STORAGE_KEY
const getPeopleInfo = () => {
  const data = window.localStorage.getItem(MIXPANEL_STORAGE_KEY + getBuildingId())
  try {
    const obj = JSON.parse(data)
    if (obj.version === VERSION) {
      return obj
    } else {
      removePeopleInfo()
      return null
    }
  } catch (e) {
    return null
  }
}
const setPeopleInfo = (data) => {
  try {
    data.version = VERSION
    data = JSON.stringify(data)
    window.localStorage.setItem(MIXPANEL_STORAGE_KEY + getBuildingId(), data)
  } catch (e) {}
}
const removePeopleInfo = () => {
  try {
    window.localStorage.removeItem(MIXPANEL_STORAGE_KEY + getBuildingId())
  } catch (e) {}
}

const env = process.env
const isDev = env.NODE_ENV === 'dev'

/**
 * Wrapper for original Mixpanel instance
 */
let inited = false
let tracking = false
const mixpanel = {
  enabled: () => {
    const user = store.state.user.user
    return user && user.customSetting ? user.customSetting.useMixpanel : false
  },
  init: () => {
    if (!mixpanel.enabled() || inited) {
      return
    }
    _MIXPANEL_.init(env.MIXPANEL_TOKEN, {
      debug: isDev,
      ignore_dnt: true,
      loaded: () => {
        console.log('< MixPanel is loaded. >')
      }
    })
    inited = true
  },
  start: (people = getPeopleInfo()) => { // pass profile to start mixpanel without saving the info
    if (!mixpanel.enabled()) {
      return
    }
    if (people) {
      mixpanel.init()
      _MIXPANEL_.identify(people.email)
      _MIXPANEL_.people.set({
        $name: people.name,
        $email: people.email,
        $phone: people.phone || ''
      })
      _MIXPANEL_.track('Landing Building', {
        objectId: getBuildingId(),
        name: store.getters.currentBuilding.name
      })
      tracking = true
    }
  },
  stop: () => {
    removePeopleInfo()
    tracking = false
  },
  track: (name, props, options) => {
    if (!inited || !tracking) {
      return
    }
    /**
     * Tracking events (Event name MUST use pre-defined value for report data sorting.)
     *
     * 0. Landing Building (auto tracked after init) - objectId, name
     * 1. Click Marker - buildingId, objectId, type, name
     * 2. Click Point - buildingId, objectId, nextPanoramaId, type, name
     * 3. Click Teleport - buildingId, objectId, nextBuildingId, nextPanoramaId, type, name
     * 4. Change Panorama - buildingId, objectId, name
     */
    _MIXPANEL_.track(name, props, options)
  },
  tracking: () => tracking,
  getPeopleInfo,
  setPeopleInfo,
  removePeopleInfo
}

Vue.prototype.$mixpanel = mixpanel

export default mixpanel
